gsap.registerPlugin(ScrollTrigger);

// Inicializa Lenis
const lenis = new Lenis({
  smoothWheel: true,
  duration: 1.2
});

lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);

// ScrollTrigger pinning para cada sección
gsap.utils.toArray('.panel').forEach((section) => {
  const nextSection = section.nextElementSibling;
  ScrollTrigger.create({
    trigger: section,
    start: 'top top',
    end: 'bottom top',
    pin: true,
    pinSpacing: false,
    scrub: 0.5,
    anticipatePin: 1,
    invalidateOnRefresh: true
  });

  if (nextSection) {
    gsap.to(section, {
      opacity: 0,
      scrollTrigger: {
        trigger: nextSection,
        start: 'top bottom',
        end: 'top top',
        scrub: 0.5,
        ease: 'power4.inOut'
      }
    });
  }
});

// Función para animar cada sección individualmente
function animateSection(animatedTextClass, splitText, mobileSplit) {
  const animatedText = document.querySelector(animatedTextClass);
  if (animatedText) {
    let textContent = splitText;
    if (window.innerWidth <= 768 && mobileSplit) {
      textContent = mobileSplit;
    }
    animatedText.innerHTML = textContent
      .split("")
      .map((char) => {
        if (char === "\n") return "<br>";
        if (char === " ") return `<span class="blank">&nbsp;</span>`;
        return `<span>${char}</span>`;
      })
      .join("");

    const panel = animatedText.closest('.panel');

    // Animar borde
    gsap.to(animatedText.closest('.border-effect'), {
      opacity: 1,
      scale: 1,
      duration: 1,
      ease: 'power4.out',
      scrollTrigger: {
        trigger: panel,
        start: 'top center',
        toggleActions: 'play none none reverse'
      }
    });

    // Animar letras letra a letra
    const spans = animatedText.querySelectorAll("span");

    gsap.fromTo(spans,
      { opacity: 0 },
      {
        opacity: 1,
        stagger: 0.1,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: panel,
          start: "top center",
          toggleActions: 'play none none reverse'
        }
      }
    );
  }
}

// Animaciones para cada sección
animateSection('.animated-text-1', 'SOBRE NOSOTROS', 'SOBRE\nNOSOTROS');
animateSection('.animated-text-2', 'TALLERES Y OFICINAS', 'TALLERES\nY OFICINAS');
animateSection('.animated-text-3', 'COLABORACIONES');
animateSection('.animated-text-4', 'COLECCIONES');
animateSection('.animated-text-5', 'BOUTIQUES');

const contactSection = document.querySelector('#shopify-section-template--23745235485010__contact_form_ybkmfR');

if (contactSection) {
    gsap.to('.boutiques', {
        opacity: 0,
        scrollTrigger: {
            trigger: contactSection,
            start: 'top bottom',
            end: 'top top',
            scrub: 0.5,
        }
    });
}




